import React from 'react'
import Button from 'presentation/shared/components/Button'
import { Container } from 'presentation/shared/components/Container'
import Heading from 'presentation/shared/components/Heading'
import SupportText from 'presentation/shared/components/SupportText'

import * as S from './styles'
import { useHistory } from 'react-router-dom'

export default function InvalidRegisterLayout() {
  const history = useHistory()
  return (
    <Container>
      <S.Wrapper>
        <Heading as="h1" size="large">
          Seus dados não foram validados
        </Heading>
        <S.Content>
          {/* to-do: add a real email above */}
          <SupportText>
            Para liberarmos seu acesso envie para{' '}
            <strong>contato@redfox.tech</strong> os seguintes documentos:
          </SupportText>
          <SupportText>
            <strong>
              um documento oficial com foto email que deseja atualizar.
            </strong>
          </SupportText>
          <SupportText>
            Em até 2 dias úteis retornaremos no email indicado e você poderá
            prosseguir com o cadastro na solução.
          </SupportText>
        </S.Content>
        <Button type="button" fullWidth onClick={() => history.push('/login')}>
          Fechar
        </Button>
      </S.Wrapper>
    </Container>
  )
}
